<template>
  <div>
    <!-- <p>{{$store.state.selectedPlaces}}</p>
    <p>{{$store.state.selectedRegions}}</p>
    <button v-on:click="addValue">Add value</button>
    <b-form-checkbox
       :checked="true"
    >omg</b-form-checkbox>-->
    <!-- <font-awesome-icon icon="user-secret" /> -->

    <b-form>
      <label v-b-toggle.collapse-1>Locatie:</label>
      <div class="filter">
        <div
          v-for="(options, index) in $store.getters.regionsPlacesOptions"
          :key="index"
        >
          <div class="row1">
            <b-form-checkbox
              :checked="options.region.allSelected"
              :indeterminate="options.region.indeterminate"
              :key="options.region.value"
              :disabled="options.region.disabled"
              @change="addValue($event, index)"
              :name="options.region.value"
              >{{ options.region.value }} ({{
                options.region.selectedPlacesCount
              }}/{{ options.region.placesCount }})</b-form-checkbox
            >
            <span
              class="collapseSpan"
              v-on:click="toggleCollapseRegion(options, index)"
            >
              <font-awesome-icon
                class="plusMinus"
                v-if="options.region.collapsed"
                icon="minus"
              />
              <font-awesome-icon class="plusMinus" v-else icon="plus" />
            </span>
          </div>
          <div class="indentedCheckboxes">
            <b-collapse v-model="options.region.collapsed" class>
              <!-- <p v-for="(option) in options.places" :key="option.value">{{option.value}}</p> -->
              <b-form-checkbox
                v-for="option in options.places"
                v-model="selectedPlaces"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
                @change="updateFilters()"
                name="flavour-3a"
                >{{ option.value }} ({{ option.count }})</b-form-checkbox
              >
            </b-collapse>
          </div>
        </div>
      </div>
      <div class="filter">
        <label>Contracttype:</label>
        <b-form-checkbox
          v-for="option in $store.getters.contractTypeOptions"
          v-model="selectedContractTypes"
          :key="option.value"
          :value="option.value"
          :disabled="option.disabled"
          @change="updateFilters()"
          name="flavour-3a"
          >{{ option.value }} ({{ option.count }})</b-form-checkbox
        >
      </div>

      <!-- JobFunction checkboxes-->
      <!-- <label class="mr-sm-2" for="jobFunctionInput">Contracttype:</label>
      <b-form-group>
        <b-form-checkbox-group
          :options="$store.getters.contractTypeOptions"
          @change="mutateSelectedContractTypes"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>-->
      <div class="filter">
        <label>Vakgebied:</label>
        <b-form-checkbox
          v-for="option in $store.getters.industryOptions"
          v-model="selectedIndustries"
          :key="option.value"
          :value="option.value"
          :disabled="option.disabled"
          @change="updateFilters()"
          name="flavour-3a"
          >{{ option.value }} ({{ option.count }})</b-form-checkbox
        >
      </div>

      <!-- <label class="mr-sm-2" for="jobFunctionInput">Opleidingsniveau:</label>
      <b-form-group>
        <b-form-checkbox-group
          :options="$store.getters.educationLevelOptions"
          @change="mutateSelectedEducationLevels"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>-->
      <div class="filter">
        <label>Opleidingsniveau:</label>
        <b-form-checkbox
          v-for="option in $store.getters.educationLevelOptions"
          v-model="selectedEducationLevels"
          :key="option.value"
          :value="option.value"
          :disabled="option.disabled"
          @change="updateFilters()"
          name="flavour-3a"
          >{{ option.value }} ({{ option.count }})</b-form-checkbox
        >
      </div>

      <!-- JobFunction -->
      <!-- <label class="mr-sm-2" for="jobFunctionInput">Functie:</label>
      <div class="pb-3 row1">
        <b-form-select
          id="jobFunctionInput"
          :options="filteredJobFunctions"
          :value="selectedJobFunction"
          @change="mutateSelectedJobFunction"
        ></b-form-select>
      </div>-->

      <!-- Area -->
      <!-- <label class="mr-sm-2" for="areaInput">Locatie:</label>
      <div class="pb-3 row1">
        <b-form-select
          id="areaInput"
          :options="filteredAreas"
          :value="selectedArea"
          @change="mutateSelectedArea"
        ></b-form-select>
      </div>-->
    </b-form>
    <!-- <p>{{jobs}}</p> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      collapsedRegions: {},
      searchParamsToggle: false,
      selected: [], // Must be an array reference!
      options: [
        { text: "Orange", value: "orange" },
        { text: "Apple", value: "apple" },
        { text: "Pineapple", value: "pineapple" },
        { text: "Grape", value: "grape" },
      ],
    };
  },
  computed: {
    searchParams: function () {
      let searchParams = new URLSearchParams();
      if (this.searchParamsToggle) {
        let selectedFiltersDictionary = new Object();
        selectedFiltersDictionary = {
          selectedPlaces: this.$store.state.selectedPlaces,
          selectedRegions: this.$store.state.selectedRegions,
          selectedContractTypes: this.$store.state.selectedContractTypes,
          selectedIndustries: this.$store.state.selectedIndustries,
          selectedEducationLevels: this.$store.state.selectedEducationLevels,
        };
        for (const selectedProperty in selectedFiltersDictionary) {
          let values = selectedFiltersDictionary[selectedProperty];
          for (const value in values) {
            searchParams.append(selectedProperty, values[value]);
          }
        }

        var questionMark = "";
        for (var value of searchParams.values()) {
          questionMark = "?";
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          questionMark +
          searchParams;
        window.history.replaceState({ path: newurl }, "", newurl);
      }
      return searchParams;
    },
    selectedRegions: {
      get() {
        return this.$store.state.selectedRegions;
      },
      set(value) {
        this.$store.commit("mutateSelectedRegions", value);
      },
    },
    selectedPlaces: {
      get() {
        return this.$store.state.selectedPlaces;
      },
      set(value) {
        this.$store.commit("mutateSelectedPlaces", value);
      },
    },
    selectedContractTypes: {
      get() {
        return this.$store.state.selectedContractTypes;
      },
      set(value) {
        this.$store.commit("mutateSelectedContractTypes", value);
      },
    },
    selectedIndustries: {
      get() {
        return this.$store.state.selectedIndustries;
      },
      set(value) {
        this.$store.commit("mutateSelectedIndustries", value);
      },
    },
    selectedEducationLevels: {
      get() {
        return this.$store.state.selectedEducationLevels;
      },
      set(value) {
        this.$store.commit("mutateSelectedEducationLevels", value);
      },
    },

    // For an explaination of the following section:
    // https://vuex.vuejs.org/guide/forms.html
    ...mapState(["selectedJobFunction", "selectedArea", "jobs"]),
    ...mapGetters([
      "filteredJobs",
      "jobFunctions",
      "filteredJobFunctions",
      "areas",
      "filteredAreas",
    ]),
    ...mapActions(["loading"]),
  },
  mounted() {
    
    let searchParams = new URLSearchParams(window.location.search);

    let selectedPlaces = searchParams.getAll("selectedPlaces");
    this.$store.commit("mutateSelectedPlaces", selectedPlaces);

    let selectedRegions = searchParams.getAll("selectedRegions");
    this.$store.commit("mutateSelectedRegions", selectedRegions);

        let selectedContractTypes = searchParams.getAll("selectedContractTypes");
    this.$store.commit("mutateSelectedContractTypes", selectedContractTypes);

        let selectedIndustries = searchParams.getAll("selectedIndustries");
    this.$store.commit("mutateSelectedIndustries", selectedIndustries);

        let selectedEducationLevels = searchParams.getAll("selectedEducationLevels");
    this.$store.commit("mutateSelectedEducationLevels", selectedEducationLevels);

    this.searchParamsToggle = true;
  },
  methods: {
    toggleCollapseRegion(options, index) {
      this.$store.commit("addCollapsedRegion", options.region.value);
    },
    countsPlaces(places) {
      let total = 0;
      places.forEach((place) => {
        total += place.count;
      });
      return total;
    },
    addValue(event, regionIndex) {
      this.updateFilters();

      let places = this.$store.getters.regionsPlacesOptions[regionIndex].places;

      let selectedPlaces = this.$store.state.selectedPlaces;
      if (event != null && event != false) {
        for (let placeIndex = 0; placeIndex < places.length; placeIndex++) {
          selectedPlaces.push(places[placeIndex].value);
        }
      } else {
        for (let placeIndex = 0; placeIndex < places.length; placeIndex++) {
          selectedPlaces = selectedPlaces.filter(function (place) {
            return place !== places[placeIndex].value;
          });
        }
      }

      this.$store.commit("mutateSelectedPlaces", selectedPlaces);
    },
    mutateSelectedContractTypes(value) {
      this.$store.commit("mutateSelectedContractTypes", value);
    },
    mutateSelectedIndustries(value) {
      this.$store.commit("mutateSelectedIndustries", value);
    },
    mutateSelectedArea(value) {
      this.$store.commit("mutateSelectedArea", value);
    },
    mutateSelectedEducationLevels(value) {
      this.$store.commit("mutateSelectedEducationLevels", value);
    },
    updateFilters() {
      //Emit updated
      this.$emit('filtersUpdated');
    }
  },
};
</script>

<style scoped>
.plusMinus {
  height: 10px;
  margin-bottom: 2px;
}
.collapseSpan {
  margin-left: auto;
}
.columnLeft {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.columnRight {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.filter {
  margin-bottom: 20px;
}

.indentedCheckboxes {
  margin-left: 30px;
}
</style>